const ProductComponent = () => import('@/views/WareHouse/Product/ProductView')

export default [
    {
        path:'/ProductIndex',
        name:'ProductComponent',
        component:ProductComponent
    }
]